'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themer = require('../../../../themer');

var _memoizeClassName = require('../utils/memoizeClassName');

var _memoizeClassName2 = _interopRequireDefault(_memoizeClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var scales = _ref.scales;

  var Appearances = {};

  Appearances.default = _themer.Themer.createTableCellAppearance({
    focus: {
      outline: 'none',
      backgroundColor: scales.primary.P2A,
      boxShadow: 'inset 0 0 0 1px ' + scales.primary.P7A
    }
  });

  /**
   * Get the appearance of a `TableCell`.
   * @param {string} appearance
   * @return {string} the appearance object.
   */
  var getAppearance = function getAppearance() {
    return Appearances.default;
  };

  /**
   * Get the className of a `Table.EditableCell`.
   * @param {string} appearance
   * @return {string} the appearance class name.
   */
  return (0, _memoizeClassName2.default)(getAppearance);
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvY3JlYXRlLXRoZW1lL2Jhc2UvZ2V0VGFibGVDZWxsQ2xhc3NOYW1lLmpzIl0sIm5hbWVzIjpbInNjYWxlcyIsIkFwcGVhcmFuY2VzIiwiZGVmYXVsdCIsIlRoZW1lciIsImNyZWF0ZVRhYmxlQ2VsbEFwcGVhcmFuY2UiLCJmb2N1cyIsIm91dGxpbmUiLCJiYWNrZ3JvdW5kQ29sb3IiLCJwcmltYXJ5IiwiUDJBIiwiYm94U2hhZG93IiwiUDdBIiwiZ2V0QXBwZWFyYW5jZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7O0FBQ0E7Ozs7OztrQkFFZSxnQkFBZ0I7QUFBQSxNQUFiQSxNQUFhLFFBQWJBLE1BQWE7O0FBQzdCLE1BQU1DLGNBQWMsRUFBcEI7O0FBRUFBLGNBQVlDLE9BQVosR0FBc0JDLGVBQU9DLHlCQUFQLENBQWlDO0FBQ3JEQyxXQUFPO0FBQ0xDLGVBQVMsTUFESjtBQUVMQyx1QkFBaUJQLE9BQU9RLE9BQVAsQ0FBZUMsR0FGM0I7QUFHTEMsc0NBQThCVixPQUFPUSxPQUFQLENBQWVHO0FBSHhDO0FBRDhDLEdBQWpDLENBQXRCOztBQVFBOzs7OztBQUtBLE1BQU1DLGdCQUFnQixTQUFoQkEsYUFBZ0IsR0FBTTtBQUMxQixXQUFPWCxZQUFZQyxPQUFuQjtBQUNELEdBRkQ7O0FBSUE7Ozs7O0FBS0EsU0FBTyxnQ0FBaUJVLGFBQWpCLENBQVA7QUFDRCxDIiwiZmlsZSI6ImdldFRhYmxlQ2VsbENsYXNzTmFtZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFRoZW1lciB9IGZyb20gJy4uLy4uLy4uLy4uL3RoZW1lcidcbmltcG9ydCBtZW1vaXplQ2xhc3NOYW1lIGZyb20gJy4uL3V0aWxzL21lbW9pemVDbGFzc05hbWUnXG5cbmV4cG9ydCBkZWZhdWx0ICh7IHNjYWxlcyB9KSA9PiB7XG4gIGNvbnN0IEFwcGVhcmFuY2VzID0ge31cblxuICBBcHBlYXJhbmNlcy5kZWZhdWx0ID0gVGhlbWVyLmNyZWF0ZVRhYmxlQ2VsbEFwcGVhcmFuY2Uoe1xuICAgIGZvY3VzOiB7XG4gICAgICBvdXRsaW5lOiAnbm9uZScsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHNjYWxlcy5wcmltYXJ5LlAyQSxcbiAgICAgIGJveFNoYWRvdzogYGluc2V0IDAgMCAwIDFweCAke3NjYWxlcy5wcmltYXJ5LlA3QX1gXG4gICAgfVxuICB9KVxuXG4gIC8qKlxuICAgKiBHZXQgdGhlIGFwcGVhcmFuY2Ugb2YgYSBgVGFibGVDZWxsYC5cbiAgICogQHBhcmFtIHtzdHJpbmd9IGFwcGVhcmFuY2VcbiAgICogQHJldHVybiB7c3RyaW5nfSB0aGUgYXBwZWFyYW5jZSBvYmplY3QuXG4gICAqL1xuICBjb25zdCBnZXRBcHBlYXJhbmNlID0gKCkgPT4ge1xuICAgIHJldHVybiBBcHBlYXJhbmNlcy5kZWZhdWx0XG4gIH1cblxuICAvKipcbiAgICogR2V0IHRoZSBjbGFzc05hbWUgb2YgYSBgVGFibGUuRWRpdGFibGVDZWxsYC5cbiAgICogQHBhcmFtIHtzdHJpbmd9IGFwcGVhcmFuY2VcbiAgICogQHJldHVybiB7c3RyaW5nfSB0aGUgYXBwZWFyYW5jZSBjbGFzcyBuYW1lLlxuICAgKi9cbiAgcmV0dXJuIG1lbW9pemVDbGFzc05hbWUoZ2V0QXBwZWFyYW5jZSlcbn1cbiJdfQ==